<template>
  <!-- Modal to create accounts -->
  <b-modal
    :no-close-on-backdrop="true"
    ref="accountsform"
    id="accountsform"
    body-class="bg-white"
    :title="page == 'create' ? 'New Account' : 'Edit Account'"
    cancel-title="Cancel"
    cancel-variant="light"
    @cancel="update()"
    :ok-title-html="
      page == 'create'
        ? submitted == true
          ? loaderIcon + 'Save'
          : 'Save'
        : this.page == 'update'
        ? submitted == true
          ? loaderIcon + 'Update'
          : 'Update'
        : 'Save'
    "
    :class="{ unselectable: submitted }"
    @ok.prevent="onSubmit"
    :ok-disabled="submitted"
    button-size="sm"
    @shown="
      error_show = false;
      callparentaccount();
    "
  >
    <div class="container-fluid">
      <!-- to display an error message -->
      <b-alert
        class="alert-transparent alert-danger"
        :show="error_show && this.errors.any()"
      >
        <button type="button" @click="error_show = false" class="close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div v-for="item in errors.items" :key="item.id">
          <p class="fw-semi-bold">{{ item.msg }}</p>
        </div>
      </b-alert>
    </div>
    <!-- Account type -->
    <b-row class="mt-4 text-left">
      <b-col>
        <b-form-group
          horizontal
          :label-cols="4"
          label="Account Type"
          label-for="acc_type"
          class="pr-3 pl-1"
        >
          <div style="max-width: 295px">
            <select
              class="form-control"
              name="Account"
              data-vv-name="Account"
              v-model.trim="field.gl_acc_type_id"
              @change="
                callparentaccount();
                field.is_sub_account = 0;
                field.gl_parent_acc_id = '';
              "
              v-validate="'required'"
            >
              <template v-for="item in detail_list.accounts.parent_accounts">
                <optgroup :label="item.gl_acc_type" :key="item.index">
                  <option
                    v-for="child in detail_list.accounts.child_accounts[
                      item.gl_acc_type_id
                    ]"
                    :key="child.id"
                    :value="child.gl_acc_type_id"
                  >
                    {{ child.gl_acc_type }}
                  </option>
                </optgroup>
              </template>
            </select>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Account name -->
    <b-row class="text-left">
      <b-col>
        <b-form-group
          horizontal
          :label-cols="4"
          label="Account Name"
          label-for="acc_name"
          class="pr-3 pl-1"
        >
          <div style="max-width: 295px">
            <b-form-input
              type="text"
              size="sm"
              name="Account Name"
              data-vv-name="Account Name"
              v-model.trim="field.gl_acc_name"
              v-validate="'required|max:100'"
            />
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Sub account or not -->
    <b-row class="text-left">
      <b-col>
        <b-form-group
          horizontal
          :label-cols="4"
          label="Is Sub Account ?"
          label-for="is_sub_account"
          class="pr-3 pl-1"
        >
          <b-form-radio-group
            :disabled="
              detail_list.sub_account_category.filter(
                (item) => item.value != field.gl_acc_id
              ).length == 0
            "
            @input="callparentaccount()"
            v-model.trim="field.is_sub_account"
            :options="is_sub_acc"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Sub account and its type-->
    <b-row class="text-left" v-show="field.is_sub_account == 1 ? true : false">
      <b-col>
        <b-form-group
          horizontal
          :label-cols="4"
          label="Account Type"
          label-for="acc_type"
          class="pr-3 pl-1"
        >
          <div style="max-width: 295px">
            <select
              v-validate="field.is_sub_account == 1 ? 'required' : ''"
              name="Parent Account"
              data-vv-name="sub account type"
              id="sub_account_parent"
              class="form-control chosen"
              v-model.trim="field.gl_parent_acc_id"
              v-chosen="field.gl_parent_acc_id"
            >
              <option
                v-if="item.value != field.gl_acc_id"
                v-for="(item, index) in detail_list.sub_account_category"
                :value="item.value"
                :key="index"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="text-left">
      <b-col>
        <b-form-group
          horizontal
          :label-cols="4"
          label="Account Code"
          label-for="acc_code"
          class="pr-3 pl-1"
        >
          <div style="max-width: 295px">
            <b-form-input
              type="text"
              size="sm"
              name="Account Code"
              data-vv-name="Account Code"
              v-model.trim="field.acc_code"
              v-validate="'max:50'"
            />
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Description -->
    <b-row class="text-left">
      <b-col>
        <b-form-group
          horizontal
          :label-cols="4"
          label="Notes"
          class="pr-3 pl-1"
          label-for="notes"
        >
          <div style="max-width: 295px">
            <b-form-textarea
              id="note"
              name="Account Description"
              rows="3"
              v-model="field.gl_acc_desc"
              data-vv-name="Account Description"
              v-validate="'max:500'"
            />
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
//import needed functions, file , components and state
import { EventBus } from "@/event-bus"; //To create an event bus
import { mapState } from "vuex"; // to access state from all the vuex file
import store from "@/store/index"; // to call all vuex state
import Vue from "vue"; //vue
import $ from "jquery"; //jquery
import "chosen-js/chosen.min.css"; //for v-chosen to select and show the drop down
import "chosen-js/chosen.jquery.min.js"; //for v-chosen to select and show the drop down
//  to get chosen dropdown
Vue.directive("chosen", {
  inserted: function (el, binding, vnode) {
    $(el)
      .chosen()
      .change(function (event, change) {
        if (Array.isArray(binding.value)) {
          var selected = binding.value;
          if (change.hasOwnProperty("selected")) {
            selected.push(change.selected);
          } else {
            selected.splice(selected.indexOf(change.deselected), 1);
          }
        } else {
          var keys = binding.expression.split(".");
          var pointer = vnode.context;

          var pointerConditions =
            pointer[binding.expression.split(".").shift()];
          while (keys.length > 1) {
            if (typeof pointerConditions == "undefined") {
              var string = el.name.split(" ");
              var val = parseInt(string[4]) - 1;
              pointer["items"][val][keys["1"]] = change.selected;
            } else {
              pointer = pointer[keys.shift()];
              pointer[keys[0]] = change.selected;
            }
            break;
          }
        }
      });
  },
  componentUpdated(el) {
    $(el).trigger("chosen:updated");
  },
});
export default {
  props: ["page"],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      SubAccount: [],
      error_show: false,
      is_sub_acc: [
        {
          text: "Yes",
          value: 1,
        },
        {
          text: "No",
          value: 0,
        },
      ],
    };
  },

  methods: {
    //To update
    async updateFreshEventObject($event) {
      this.field = await $event;
      await this.callparentaccount();
      this.field.gl_parent_acc_id = $event.gl_parent_acc_id;
    },
    //Declaring the field
    createFreshEventObject() {
      this.field = {
        gl_acc_type_id: "8",
        gl_acc_name: "",
        is_sub_account: "0",
        gl_parent_acc_id: "",
        gl_acc_desc: "",
      };
    },
    //to get the info clearly after providing cancel
    async update() {
      {
        const currentPage = parseInt(this.$route.query.page) || 1;
        const show = parseInt(this.$route.query.show) || 10;
        const search = this.$route.query.search || "";
        const status = this.$route.query.status || "";
        const label = this.$route.query.label || "";
        const sort = this.$route.query.sort || "";
        const custom = this.$route.query.custom || "";
        const response = await store
          .dispatch("accounts/fetchLists", {
            page: currentPage,
            show: show,
            search: search,
            status: status,
            sort: sort,
            label: label,
            custom: custom,
          })
          .then(() => {
            return this.export;
          });
        return response;
      }
    },
    //During submit
    onSubmit() {
      if (this.field.is_sub_account != 1) {
        this.detail_list.sub_account_category = [];
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          if (this.page == "create") {
            this.$store
              .dispatch("accounts/createList", {
                field: this.field,
              })
              .then(() => {
                this.submitted = false;
                this.FormUpdate = 0; // to hide before route leave confirmation message
                var message;
                var type;
                const update = this.$route.query.update;
                const update_status = update == true ? false : true;
                this.$store.dispatch("accounts/fetchAccountDetails");
                if (this.code == 200) {
                  //  show if invoice successfully created
                  this.$refs.accountsform.hide();
                  message = "Accounts has been created successfully!";
                  type = "success";
                  this.submitted = false;
                  this.$router.push({
                    name: "AccountSettings",
                    query: {
                      update: update_status,
                    },
                  });
                } else {
                  //  show if invoice successfully created

                  message = "Account with this Name already exist!";
                  type = "danger";
                  this.submitted = false;
                  this.$router.push({
                    name: "AccountSettings",
                    query: {
                      update: update_status,
                    },
                  });
                }
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: message,
                  type: type,
                  showCloseButton: true,
                });
              })
              .catch(() => {});
          }
          //    accounts update
          if (this.page == "update") {
            this.$store
              .dispatch("accounts/updateList", {
                id: this.field.gl_acc_id,
                field: {
                  field: this.field,
                },
              })
              .then(() => {
                this.submitted = false;
                this.FormUpdate = 0; // to hide before route leave confirmation message
                var message;
                var type;
                const update = this.$route.query.update;
                const update_status = update == true ? false : true;
                this.$store.dispatch("accounts/fetchAccountDetails");
                if (this.code == 200) {
                  //  show if invoice successfully created
                  this.$refs.accountsform.hide();
                  message = "Accounts has been updated successfully!";
                  type = "success";
                  this.$router.push({
                    name: "AccountSettings",
                  });
                } else {
                  //  show if invoice successfully created

                  message = "Account with this Name already exist!";
                  type = "danger";
                  this.submitted = false;
                  this.$router.push({
                    name: "AccountSettings",
                    query: {
                      update: update_status,
                    },
                  });
                }
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: message,
                  type: type,
                  showCloseButton: true,
                });
              })
              .catch(() => {});
          }
        } else {
          this.error_show = true;
        }
      });
    },
    //To call parent account for sub account
    callparentaccount() {
      this.SubAccount = [];
      this.detail_list.sub_account_category = this.buildOptionArray(
        "",
        this.detail_list.sub_account_parent[this.field.gl_acc_type_id],
        0,
        0
      );

      this.$nextTick(() => {
        $(function () {
          $(".chosen").trigger("chosen:updated");
        });
      });
    },
    has_children_tree(rows, id) {
      var hasMatch = "";
      for (var i = 0; i < rows.length; i++) {
        if (rows[i]["parent_id"] == id) {
          hasMatch = true;
          break;
        }
      }
      return hasMatch;
    },
    //To build an option array from parent accounts
    buildOptionArray(child, rows, parent = 0, k) {
      var spaces = "--";
      var i = k;
      $.each(rows, (index, value) => {
        if (value["parent_id"] == parent) {
          spaces = [];
          for (var j = 0; j < i; j++) {
            spaces.push("--");
          }
          spaces = spaces.length > 0 ? spaces.join("-") + "--" : "";
          var label = spaces + value["label"];
          j = i;
          this.SubAccount.push({
            label: label,
            value: value["value"],
          });
          if (this.has_children_tree(rows, value["value"])) {
            this.buildOptionArray(
              "",
              this.detail_list.sub_account_parent[this.field.gl_acc_type_id],
              value["value"],
              parseInt(i) + 1
            );
          } else {
            i = j;
          }
        }
      });
      return this.SubAccount;
    },
  },
  // called after the vue instance mounted
  mounted() {
    EventBus.$on("createFreshEventObject", this.createFreshEventObject); // to trigger the method from parentcomponent
    EventBus.$on("updateFreshEventObject", this.updateFreshEventObject); // to trigger the method from parentcomponent
  },
  // called synchronously after the vue instance created
  created() {
    this.$nextTick(() => {
      $(function () {
        $(".chosen").chosen();
      });
    });
  },
  computed: {
    // to get the required data from the vuex state
    ...mapState({
      list: (state) => state.accounts.list, //To get the accounts list
      code: (state) => state.accounts.code, //to get the accounts code
      detail_list: (state) => state.accounts.detail_list, //List of accounts
    }),
    //To get the update fields and to pass fields
    field: {
      get() {
        return this.$store.state.accounts.field;
      },
      set(val) {
        return (this.$store.state.accounts.field = val);
      },
    },
  },
};
</script>